import encrypt from "./encrypt";

/**
 * 对缓存进行加密解密
 *
 */
export const storeInfoCrypt = state => {
  //缓存加密
  let data = encrypt.Encrypt(JSON.stringify(state));
  window.localStorage.setItem("storeInfo", data);
};

export const storeInfoDecrypt = str => {
  let data = "";
  if (str) {
    data = JSON.parse(encrypt.Decrypt(str));
  }
  return data;
};
